export default __webpack_public_path__ + "static/media/create-password-icon.f9205a43.svg";